import useBrowser from '@Hooks/myhouse/useBrowser'
import { MOBILE_REGEX } from '@Root/contants'

declare global {
  interface Window {
    lcs_SerName?: string
    ccsrv?: string
    g_ssc?: string
    nsc?: string
    MSStream?: any
  }
  interface globalThis {
    lcs_SerName?: string
    ccsrv?: string
    g_ssc?: string
    nsc?: string
    MSStream?: any
  }
}

const getSsc = () => {
  if (MOBILE_REGEX.IS_PAY_APP.test(navigator.userAgent)) {
    return process.env.NCLICK_PAYAPP_SSC
  }
  return process.env.NCLICK_GLOBAL_SSC
}

export const lcsInitialize = (exportTarget: Window | globalThis) => {
  exportTarget.lcs_SerName = process.env.LCS_SERVER_NAME
}

export const nclickInitialize = (exportTarget: Window | globalThis) => {
  exportTarget.ccsrv = process.env.NCLICK_CC_SERVER_NAME
  exportTarget.g_ssc = getSsc()
  exportTarget.nsc = exportTarget.g_ssc
}

export const initialize = (exportTarget: Window | globalThis) => {
  if (exportTarget instanceof Window) {
    lcsInitialize(exportTarget)
    nclickInitialize(exportTarget)
  }
}

initialize(window)
